// extracted by mini-css-extract-plugin
export default {"btn":"OptionsButton_btn__LTcEV","icon":"OptionsButton_icon__BA-Yh","text":"OptionsButton_text__ISZjm"};